import { get, put } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';

import { I18n } from "aws-amplify/utils";
import {setAppLanguage} from "../Utils";

const apiName = "api-maitrise";
const baseUrl = "/maitrise";

const getAuthHeaders = async () => {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString();
    return idToken ? { Authorization: `Bearer ${idToken}` } : {};
};

/**
 * Update the profile of the current user
 * @param user - The user object that will be updated.
 * @param callBack - A function that will be called when the request is completed.
 */
export function updateMyProfile(user, callBack) {
    const _user = JSON.parse(JSON.stringify(user));
    (async () => {
        const restOperation = put({
            apiName,
            path: `${baseUrl}/user`,
            options: {
                headers: await getAuthHeaders(),
                body: _user
            }
        });

        restOperation.response
            .then(() => {
                callBack();
            })
            .catch(err => { callBack(err); });
    })().catch(err => callBack(err));
}

/**
 * Complete the profile of the current authenticated user with data from database
 * @param userData - The userData object that contains data of authenticated user.
 * @param identityData - The identityData object that contains data of authenticated user from identity provider.
 * @param callBack - A function that will be called when the request is completed.
 */
export function completeMyProfile(userData, identityData, callBack) {
    (async () => {
        const restOperation = get({
            apiName,
            path: `${baseUrl}/user`,
            options: {
                cache: 'no-store',
                headers: await getAuthHeaders()
            }
        });

        restOperation.response
            .then(async ({ body }) => {
                const userLoaded = await body.json();

                const authenticatedUserData = {
                    ...userLoaded,
                    email: userData.attributes.email,
                    email_verified: userData.attributes.email_verified,
                    phone_number: userData.attributes.phone_number,
                    phone_number_verified: userData.attributes.phone_number_verified,
                    groups: userData.attributes['cognito:groups'] ? userData.attributes['cognito:groups'] : [],
                    username: userData.username,
                    identityId: identityData.identityId
                };

                if (authenticatedUserData.preferedLanguage && !I18n.get('language').startsWith(authenticatedUserData.preferedLanguage.toLowerCase())) {
                    setAppLanguage(authenticatedUserData.preferedLanguage.toLowerCase());
                }

                callBack(authenticatedUserData);
            })
            .catch(err => console.log(err));
    })().catch(err => console.log(err));
}

/**
 * Refresh state by getting information from cognito and dynamoDb user
 * @param setGlobalUserData - Method to update user data from global state.
 */
export async function refreshAuthenticationData(setGlobalUserData) {
    try {
        const { tokens, identityId } = await fetchAuthSession();

        const userData = tokens?.idToken?.payload ?? {};

        const identityData = {
            identityId
        };

        completeMyProfile(
            {
                attributes: {
                    email: userData.email,
                    email_verified: userData.email_verified,
                    phone_number: userData.phone_number,
                    phone_number_verified: userData.phone_number_verified,
                    'cognito:groups': userData['cognito:groups']
                },
                username: userData['cognito:username'] || userData.username
            },
            identityData,
            setGlobalUserData
        );
    } catch (e) {
        console.log(e);
    }
}
